import Control from "ol/control/Control";

export class BoundaryCodesControl extends Control {
  constructor(opt_options) {
    const options = opt_options || {};
    const element = document.createElement("ul");
    super({
      element: element,
      target: options.target,
    });
    element.className = "boundary-codes-display ol-unselectable";

    const codesDiv = document.createElement("div");
    codesDiv.className = "boundary-codes-list";
    element.appendChild(codesDiv);

    this.codesDiv = codesDiv;
  }

  setBoundaryCodes(codes) {
    if (codes && codes.length > 0) {
      this.codesDiv.textContent = codes;
      this.codesDiv.style.display = "block";
    } else {
      this.codesDiv.style.display = "none";
    }
  }

  setError(errorMessage) {
    // Silently hide on error - no error messages shown
    console.error("Boundary codes error:", errorMessage);
    this.codesDiv.style.display = "none";
  }
}
